module.exports = __webpack_public_path__ + "six.f3c171d1caffe8c3abca.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/six/six.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/six/six.jpg
// module chunks = 0